import { RouteEnum } from "requests";

export const ROUTES_LABELS = {
  [RouteEnum.Iv]: "IV",
  [RouteEnum.Sc]: "SC",
  [RouteEnum.Im]: "IM",
  [RouteEnum.Po]: "PO",
  [RouteEnum.Td]: "TD"
};
